// extracted by mini-css-extract-plugin
export default {"popoverWrapper":"Popover_popoverWrapper__aKZUY","popoverPanel":"Popover_popoverPanel__eGWjB"};